import { Global } from "@emotion/react";
import { Fragment } from "react";
import tw, { GlobalStyles as BaseStyles, css } from "twin.macro";
// import { useTernaryDarkMode } from "usehooks-ts";

const customStyles = css`
  html,
  body,
  #root {
    ${tw`h-full`}
  }

  html {
    overflow: hidden;
  }

  body {
    ${tw`bg-background text-on-background transition duration-200 text-base md:text-sm`}
  }

  :focus:not(:focus-visible) {
    outline: none;
  }

  .dot {
    opacity: 0;
    animation: blink 1.4s infinite;
  }

  .dot:nth-child(1) {
    animation-delay: 0s;
  }
  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }
  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes blink {
    0%,
    20% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

const GlobalStyles = () => {
  //#region Dark mode management
  // const { isDarkMode } = useTernaryDarkMode();
  // useEffect(() => {
  //   const root = window.document.documentElement;
  //   root.classList.remove(isDarkMode ? "light" : "dark");
  //   root.classList.add(isDarkMode ? "dark" : "light");
  // }, [isDarkMode]);

  // useEffect(() => {
  //   const root = window.document.documentElement;
  //   root.classList.add("light");
  // }, []);
  //#endregion Dark mode management

  return (
    <Fragment>
      <BaseStyles />
      <Global styles={customStyles} />
    </Fragment>
  );
};

export default GlobalStyles;
